import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectCurrentRoute, selectRouteData, selectRouteParams } from '../../store/router/router.selector';

@Injectable({
    providedIn: 'root'
})
export class RouterFacade {
    routerParams$ = this.store.select(selectRouteParams);
    routerCurrentRoute$ = this.store.select(selectCurrentRoute);
    routeData$ = this.store.select(selectRouteData);

    constructor(private store: Store) {}
}
